import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { portalApi } from "@/lib/portalApi";

export default function PortalTemplatesPage() {
  const [templates, setTemplates] = useState([]);
  const [editing, setEditing] = useState(null);
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [htmlBody, setHtmlBody] = useState("<p>Hello {{name}},</p><p>Your update from IT-Patrol.</p>");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () =>
    portalApi.templates
      .index()
      .then((data) => setTemplates(data.email_templates))
      .catch((err) => setError(err.message));

  useEffect(() => {
    load();
  }, []);

  function resetForm() {
    setEditing(null);
    setName("");
    setSubject("");
    setHtmlBody("<p>Hello,</p><p>Your update from IT-Patrol.</p>");
  }

  async function openEdit(id) {
    setError("");
    try {
      const data = await portalApi.templates.show(id);
      const t = data.email_template;
      setEditing(t.id);
      setName(t.name);
      setSubject(t.subject);
      setHtmlBody(t.html_body);
    } catch (err) {
      setError(err.message);
    }
  }

  async function onSave(e) {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const body = { name, subject, html_body: htmlBody };
      if (editing) await portalApi.templates.update(editing, body);
      else await portalApi.templates.create(body);
      resetForm();
      await load();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  async function onDelete(id) {
    if (!window.confirm("Delete this template?")) return;
    try {
      await portalApi.templates.destroy(id);
      if (editing === id) resetForm();
      await load();
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <>
      <h1>Email templates</h1>
      <p className="muted">HTML templates with image tags you control</p>
      {error && <div className="portal-alert portal-alert--error">{error}</div>}

      <div className="portal-card">
        <h2>{editing ? "Edit template" : "New template"}</h2>
        <form className="portal-form" onSubmit={onSave}>
          <label>
            Name
            <input required value={name} onChange={(e) => setName(e.target.value)} />
          </label>
          <label>
            Subject
            <input required value={subject} onChange={(e) => setSubject(e.target.value)} />
          </label>
          <label>
            HTML body
            <textarea required value={htmlBody} onChange={(e) => setHtmlBody(e.target.value)} style={{ minHeight: 220 }} />
          </label>
          <p className="muted" style={{ fontSize: "0.8rem" }}>
            Embed images with absolute URLs, e.g. &lt;img src=&quot;https://…&quot; alt=&quot;&quot; /&gt;
          </p>
          <div className="portal-actions">
            <button className="btn" type="submit" disabled={busy}>
              {busy ? "Saving…" : "Save template"}
            </button>
            {editing && (
              <button type="button" className="btn btn--ghost" onClick={resetForm}>
                Cancel edit
              </button>
            )}
          </div>
        </form>
        <h3 style={{ marginTop: "1.25rem" }}>Preview</h3>
        <iframe className="portal-preview" title="Template preview" sandbox="" srcDoc={htmlBody} />
      </div>

      <div className="portal-card">
        <h2>Saved templates</h2>
        {templates.length === 0 ? (
          <p className="muted">No templates yet.</p>
        ) : (
          <table className="portal-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Subject</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {templates.map((t) => (
                <tr key={t.id}>
                  <td>{t.name}</td>
                  <td>{t.subject}</td>
                  <td className="portal-actions">
                    <button type="button" className="btn btn--ghost" onClick={() => openEdit(t.id)}>
                      Edit
                    </button>
                    <button type="button" className="btn btn--ghost" onClick={() => onDelete(t.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
